import { get } from 'svelte/store';
import { api } from '../../../../helpers';
import { flowItems, flows, selectedFlow, procentPassed } from '../store';
const apiGet = async (url, apiVersion = '/api/v1') => {
    const response = await api(`${apiVersion}${url}`);
    return await response.json();
};
export const getItemsByFlow = async (flowId) => {
    const data = await apiGet(`/flow-program/page/list/${flowId}/`);
    flowItems.set(data.flow_program_page);
    procentPassed.set(data.procent_passed);
};
export const getFlows = async () => {
    const data = await apiGet('/users/available-flow/list/');
    flows.set(data);
    selectedFlow.set(data[data.length - 1]);
};
export const getListByFlowItem = async (flowId, flowItemId) => {
    const url = `/publication/program-flow/list/${flowId}/${flowItemId}/`;
    return await apiGet(url);
};
export const selectFlow = async (flow) => {
    selectedFlow.set(flow);
    await getItemsByFlow(flow.pk);
};
export const init = async () => {
    await getFlows();
    await getItemsByFlow(get(selectedFlow).pk);
};
